import type { FaireProductEntity } from "../../entity_types/product";

export const p_xmst7hbqes: FaireProductEntity = {
  token: "p_xmst7hbqes",
  type: "product",
  name: "Doggy Thank You Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/37f30e0cf62574e1be14b40cea7103c32df89f50ce5ea7dc4efe45a207175adb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88c11bf103d917b790f4e94c96ff2e8032340d71183959f31b9354c06b9fa7e8.jpeg",
    "https://cdn.faire.com/fastly/334d681731a3dfd027f53b1e9a1d82d91c5413d5419eaf0ca1571e4513faf749.jpeg"
  ],
  priceDollars: 11,
  description: "A thank you so sincere, even these dogs feel it. Why else would they sit still long enough for their paintings to be done?! Well done, fellas.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:45.758Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
